var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"u-body u-xl-mode"},[_c('header-component'),_c('welcome'),_c('mission-vision'),_c('services'),_c('products'),_c('whats-included'),_c('what-we-do'),_c('contacto'),_c('footerComponent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }